import React , { useCallback,useEffect,useState,useContext,useRef } from 'react';
import { Input,Card,Table,Slider,Spin,Radio,Modal,Button,message,Select,InputNumber,Popover,Space,Col,Row} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import _ from "lodash";
import { APIrequest } from '../../Helpers.js'
import { parseRules } from '../Projections/Scoring'
import { UserContext } from "../../Contexts/UserContext";
import LeagueSearchCard from "../../components/LeagueSearch"

// import { useReactToPrint } from 'react-to-print';
function RDP (props) {
    const { userID } =
    useContext(UserContext);
    const [searchName,setSearchName] = useState('')
    const [teamsSearch,setTeamsSearch]=useState([12,14])
    const [QBSearch,setQBSearch]=useState('SuperFlex/2QB')
   
    const [WRSearch,setWRSearch]=useState('3WR')
    const [draftType,setDraftType]=useState('vet')
    const [TESearch,setTESearch]=useState('Yes')
    const [rdpData,setRDPData]=useState([])
    const [RDPLoading,setRDPLoading]=useState(false)
    const [filterAfterNflDraft,setFilterAfterNflDraft]=useState(true)
    

 

  // const getLeagueRules = async (L)=>{
  //   console.log("Fetching Leagues")
  //   setDraftLeaguesLoading(true)
  //   await APIrequest(`/api/mfl/pullLeagueRules?`)
  //   .then(data => {setDraftLeagues(data);setDraftLeaguesLoading(false);
  //   });
  // }

  const getRDP = async ()=>{
    console.log("Fetching RDP")
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({'draftType':draftType,'QB':QBSearch,'afterDraft':filterAfterNflDraft?"Yes":"No",
      ...WRSearch=='Either'?{'naWR':WRSearch}:{'WR':WRSearch},
      ...TESearch=='Either'?{'naTEPrem':TESearch}:{'TEPrem':TESearch},
      'minTeams':teamsSearch[0],'maxTeams':teamsSearch[1]})
    };
    
    setRDPLoading(true)
     await fetch(`/api/db/getRDP?`,requestOptions)
     .then(data => data.json())
     .then(data => {console.log(data.response);setRDPLoading(false);setRDPData(data.response);
     });
  }
      

  const onSearchNameChange = ({ target: { value } }) => {
    console.log('Search Name checked', value);
    setSearchName(value);

  };


  useEffect(() => {
    console.log("Fetching Leagues");
    getRDP()
  },[QBSearch,teamsSearch,WRSearch,TESearch,draftType,filterAfterNflDraft])
  
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: () => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          
          placeholder={`Search ${dataIndex}`}
          value={searchName}
          onChange={(e) => onSearchNameChange(e)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            onClick={() => setSearchName('')}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          {/* <Button
            type="link"
            size="small"
            onClick={() => {
             
            }}
          >
            Close
          </Button> */}
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      searchName.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchName?.select(), 100);
      }
    },
    
  });
const cols=[
    {
      title: 'Player',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name'),
      //sorter: (a,b) => a.Pickvalue-b.Pickvalue,
      render: (text, record) => {
        return (
          <div>{text}</div>
          )}

    },
    {
      title: 'Position',
      dataIndex: 'position',
      key: 'position',
      //sorter: (a,b) => a.Pickvalue-b.Pickvalue,
      render: (text, record) => {
        return (
          
          <div>{text}</div>
          )}
    },
    {
      title: 'Median RDP',
      dataIndex: 'RDP',
      key: 'RDP',
      //sorter: (a,b) => a.Pickvalue-b.Pickvalue,
      render: (text, record) => {
        return (
          
          <div>{text}</div>
          )}
    },
    {
      title: 'Median Position RDP',
      dataIndex: 'posRDP',
      key: 'posRDP',
      //sorter: (a,b) => a.Pickvalue-b.Pickvalue,
      render: (text, record) => {
        return (
          <div>{record.position+text}</div>
          )}
    },
    {
      title: 'Number of Picks',
      dataIndex: 'Sample',
      key: 'Sample',
      //sorter: (a,b) => a.Pickvalue-b.Pickvalue,
      render: (text, record) => {
        return (
          
          <div>{text}</div>
          )}
    }
  ]


    const spinner=
    <React.Fragment>
    <Spin />
    </React.Fragment>
    

    return (
        <div>
        <LeagueSearchCard
        setDraftType ={setDraftType}
        draftType ={draftType}
        setTESearch ={setTESearch} 
        TESearch ={TESearch}
        setQBSearch ={setQBSearch} 
        QBSearch ={QBSearch}
        setWRSearch ={setWRSearch}
         WRSearch ={WRSearch}
        setTeamsSearch ={setTeamsSearch} 
        teamsSearch ={teamsSearch}
        setFilterAfterNflDraft={setFilterAfterNflDraft}
        filterAfterNflDraft={filterAfterNflDraft}
        />
        <Card style={{border:'3px'}}
      title="Real Draft Position"
      > 
      {RDPLoading?<Spin/>:
      
      <Table dataSource={rdpData.filter(x=>x.name.toString().toLowerCase().includes(searchName.toLowerCase()))}
        columns={cols}
        scroll={{ x: 'max-content', y:  'max-content' }}
        pagination={{defaultPageSize:50}} 
        sticky/>
      }
      </Card>
      </div>
        
        
        )
        
    }

    export default RDP;


